<template>
  <section v-if="slice?.FeatureId">
    <div class="ct-tweakwise-product-slider__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <ProductSlider
          :products="products"
          :lazy="index > 0"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import featuredQuery from '~layers/app/graphql/twFeatured.gql'

const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { profileKey } = useTweakwise()
const products = ref([])

onMounted(() => {
  const { onResult } = useQuery(featuredQuery, () => ({
    twFeaturedId: +props.slice?.FeatureId,
    profileKey: profileKey.value,
  }))

  onResult((queryResult) => {
    if (queryResult.data?.twFeatured?.items) {
      products.value = queryResult.data?.twFeatured?.items
    }
  })
})
</script>
